// extracted by mini-css-extract-plugin
export default {"constructionDetailsContainer":"ConstructionDetails_constructionDetailsContainer__Li09w"};